import { makeStyles, createStyles } from '@material-ui/core/styles';

export default (props = {}) =>
	makeStyles(
		(theme) =>
			createStyles({
				root: {
					backgroundColor: 'rgba(0,0,0,0)',
					boxShadow: 'none',
					[theme.breakpoints.up('xl')]: {
						marginTop: theme.spacing(6),
					},
				},
				registrationLink: {
					display: 'block',
					textDecoration: 'none',
					marginTop: theme.spacing(1),
				},
				link: {
					textDecoration: 'none',
					display: 'block',
					textAlign: 'center',
					color: props.loginBackgroundColor
						? theme.palette.getContrastText(props.loginBackgroundColor)
						: theme.manakin.homeLinkColor ? theme.manakin.homeLinkColor[500] : "",
					marginTop: theme.spacing(3),
					marginBottom: theme.spacing(3),
					fontSize: '18px',
					'&:visited': {
						color: props.loginBackgroundColor
							? theme.palette.getContrastText(props.loginBackgroundColor)
							: theme.manakin.homeLinkColor ? theme.manakin.homeLinkColor[500] : "",
					},
					[theme.breakpoints.up('xl')]: {
						marginBottom: theme.spacing(8),
					},
				},
				button: {},
			}),
		{
			name: 'AppLogin',
		}
	);
